import React from 'react';

const Invoices = () => {
  return (
    <div>
      <h4>Invoices</h4>
      <p>This page is under construction.</p>
    </div>
  );
};

export default Invoices;
